module.exports = __webpack_public_path__ + "img/fr-ca_get.334174a.png";